import React from "react";
import { Spin, Button, Space } from "antd";
import { Redirect } from "react-router-dom";

class PaymentProcessing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      countdown: 10,
    };
  }

  componentDidMount() {
    // Show spinner and start countdown
    this.interval = setInterval(() => {
      this.setState((prevState) => ({
        countdown: prevState.countdown - 1,
      }));
    }, 1000);

    // Redirect after 10 seconds
    setTimeout(() => {
      this.setState({ redirect: true });
      clearInterval(this.interval);
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/conference" />;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
        }}
      >
        <Space
          direction="vertical"
          style={{
            width: "500px",
            textAlign: "center",
            background: "rgba(255, 255, 255, 0.9)",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
          }}
        >
          <Spin tip="Payment is processing..." />
          <p>
            Please wait about {this.state.countdown} seconds for us to confirm
            your payment...
          </p>
          <Button
            disabled={this.state.countdown}
            onClick={() => this.setState({ redirect: true })}
          >
            Click here if you are not redirected
          </Button>
        </Space>
      </div>
    );
  }
}

export default PaymentProcessing;
